
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/controls/sectionHeader/sectionHeader.scss.css.virtualfile';
        module.exports = {"container":"_container_y2yvp_7","title":"_title_y2yvp_12","icon":"_icon_y2yvp_14","info":"_info_y2yvp_14"};